import { render } from "./os.vue?vue&type=template&id=d028effa"
import script from "./os.vue?vue&type=script&lang=js"
export * from "./os.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__